<script>
import Gallery from './content/Gallery'
import VideoWrapper from './content/VideoWrapper'
import ProductInquiryForm from './products/ProductInquiryForm'
import PostList from './blogit/PostList'

export default {
  components: {
    Gallery,
    // VideoWrapper,
    ProductInquiryForm,
    PostList,
  }
}
</script>



// WEBPACK FOOTER //
// assets/js/components/TheContent.vue